import { SavedSearch, SavedSearchFilter } from '@creditsights/api-ui-web';
import { getDateRangeDisplayValue } from '@creditsights/creditsights-web';
import classNames from 'classnames/bind';
import React from 'react';
import { RowSelection } from '../../SearchSuggest/SearchSuggest.constants';
import styles from './SavedSearchesList.module.scss';

const cx = classNames.bind(styles);

interface SavedSearchesListProps {
  savedSearches: SavedSearch[];
  verticalIndex: number | null;
  navigateToSavedSearch: (savedSearch: SavedSearch) => void;
}

const SavedSearchesList = ({
  savedSearches,
  verticalIndex,
  navigateToSavedSearch,
}: SavedSearchesListProps): React.ReactElement => {
  const renderFilters = (filters: SavedSearchFilter[]) => {
    const lastFilterIndex = filters.length - 1;
    const getDivider = (index: number) => (lastFilterIndex === index ? '' : ', ');

    return filters.map((filter, index) => (
      <span key={filter.filterType}>
        {filter.tags.length > 1
          ? `${filter.tags.at(0)?.name} +${filter.tags.length - 1}`
          : `${filter.tags.at(0)?.name}`}
        {getDivider(index)}
      </span>
    ));
  };

  const shouldDisplayFilters = (savedSearch: SavedSearch) =>
    savedSearch.filters.length || savedSearch.dateRange || savedSearch.tab;

  return (
    <div className={cx('body')}>
      {savedSearches.map((savedSearch, index) => (
        <div
          className={cx('saved-search-item')}
          key={savedSearch.id}
          data-row-selection={index === verticalIndex ? RowSelection.Item : RowSelection.None}
          data-testid="saved-search-item"
        >
          <div
            className={cx('saved-search-left-side-container')}
            onClick={() => navigateToSavedSearch(savedSearch)}
            data-testid="saved-search-left-side-container"
          >
            <p className={cx('saved-search-title')}>
              {savedSearch.name}
              {savedSearch.keywords ? ` - ${savedSearch.keywords}` : ''}
            </p>
            {shouldDisplayFilters(savedSearch) ? (
              <p className={cx('saved-search-filters')}>
                Filters:{' '}
                {savedSearch.tab
                  ? `${savedSearch.tab}${savedSearch.dateRange || savedSearch.filters.length > 0 ? ', ' : ''}`
                  : ''}
                {`${getDateRangeDisplayValue(savedSearch.dateRange)}${
                  savedSearch.filters.length && savedSearch.dateRange ? ', ' : ''
                }`}
                {renderFilters(savedSearch.filters)}
              </p>
            ) : null}
          </div>
          <div className={cx('saved-search-right-side-container')} />
        </div>
      ))}
    </div>
  );
};

export default SavedSearchesList;
